module.exports = __webpack_public_path__ + "static/media/ic_instant_withdrawal.82b8ae00.svg";